import { IInventorySummary } from '@getgreenline/homi-shared'

export enum DisplayUnit {
  CANNABIS_WEIGHT = 'cannabisWeight',
  PRODUCT_WEIGHT = 'productWeight',
  UNITS = 'units',
  ML = 'ml',
  PRICE = 'price',
  PURCHASE_PRICE = 'purchasePrice',
}

export interface IInventorySummaryFilters {
  productSearch: string
  selectedCategoryId: string | undefined
  complianceCategoryId: number | undefined
  displayUnit: DisplayUnit
  groupBy: GroupByObject
  selectedCategoryIds: string[]

  sku: boolean
  vendor: boolean
  barcode: boolean
  name: boolean
  category: boolean
  complianceCategory: boolean
  cannabisWeight: boolean
  productWeight: boolean
  cannabisVolume: boolean

  openingInventory: boolean
  sold: boolean
  purchased: boolean
  refunded: boolean
  returned: boolean
  lost: boolean
  destroyed: boolean
  transfer: boolean
  audit: boolean
  conversion: boolean
  closingInventory: boolean

  averagePrice: boolean
  averageCost: boolean
}

export interface IInventorySummaryWithSubInventories extends IInventorySummary {
  subInventories?: IInventorySummary[]
}

export interface IExportCsvFormat {
  SKU?: string
  Barcode?: string
  Name?: string
  Vendor?: string
  Category?: string
  'Compliance category'?: string
  'Cannabis weight'?: string
  'Net product weight'?: string
  'Cannabis volume'?: string
  Opening?: string
  Sold?: string
  Purchased?: string
  Refunded?: string
  Returned?: string
  Lost?: string
  Destroyed?: string
  Transferred?: string
  Audited?: string
  Converted?: string
  Closing?: string
  'Average Price'?: string
  'Average Cost'?: string
}

export enum ColumnHeaders {
  SKU = 'SKU',
  BARCODE = 'Barcode',
  NAME = 'Name',
  VENDOR = 'Vendor',
  BRAND = 'Brand',
  CATEGORY = 'Category',
  COMPLIANCE_CATEGORY = 'Compliance category',
  CANNABIS_WEIGHT = 'Cannabis weight',
  NET_PRODUCT_WEIGHT = 'Net product weight',
  CANNABIS_VOLUME = 'Cannabis volume',
  OPENING = 'Opening',
  SOLD = 'Sold',
  PURCHASED = 'Purchased',
  REFUNDED = 'Refunded',
  RETURNED = 'Returned',
  LOST = 'Lost',
  DESTROYED = 'Destroyed',
  TRANSFERRED = 'Transferred',
  AUDITED = 'Audited',
  CONVERTED = 'Converted',
  CLOSING = 'Closing',
  AVERAGE_PRICE = 'Average Price',
  AVERAGE_COST = 'Average Cost',
}

export enum GroupByObject {
  PRODUCT = 'product',
  CATEGORY = 'category',
}

export const quantityColumnNames = [
  'openingInventory',
  'sold',
  'purchased',
  'refunded',
  'returned',
  'lost',
  'destroyed',
  'transfer',
  'audit',
  'conversion',
  'closingInventory',
]
